<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-football`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm-9.79 28.222L8.07 32.39C11.088 38.105 17.09 42 24 42c.293 0 .585-.007.875-.02l-.693-6.231-9.972-5.527zm20.708-3.108l-7.177 6.692.247-.027.84 7.566c6.381-1.773 11.336-6.971 12.758-13.49l-6.668-.741zm-7.489-10.8l-8.777 1.077-.778.875-1.651 8.498 8.282 4.591 6.926-6.458-4.002-8.583zm-16.942-4.206A17.931 17.931 0 006 24c0 1.613.212 3.177.61 4.664l5.549-1.959 2.173-11.179-3.845-3.418zm25.237-1.767l-4.139 5.378-.031-.024 3.452 7.404 6.993.777-.002-.207a17.96 17.96 0 00-6.273-13.328zM24 6a17.918 17.918 0 00-10.536 3.404l4.541 4.036 11.358-1.394 3.05-3.963A17.921 17.921 0 0024 6z"/></svg>
</template>
<script>

export default {
  name: 'IconFootball',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
